import type { Theme } from '@mui/material/styles'

export const getLayoutConfig = (theme: Theme, variant: string | null) => {
  const config = {
    SpendToIncome: {
      color: [theme.palette.categories.billsUtilities, theme.palette.chart.chart1] as string[],
    },
    DebtToIncome: {
      color: [theme.palette.chart.chart5, theme.palette.chart.chart1] as string[],
    },
    SavingsToIncome: {
      color: [theme.palette.chartMono.chartMono5, theme.palette.chartMono.chartMono3] as string[],
    },
  }
  return config[variant as keyof typeof config]
}
